import classNames from "classnames";
import type React from "react";

import style from "./Separator.module.css";

interface SeparatorProps {
  className?: string;
}

export const Separator: React.FC<SeparatorProps> = ({ className }) => {
  return <div className={classNames(style.separator, className)} />;
};
